import React from 'react';
import i18n from '../../i18n';
import { AppDataContext } from '../../context/Context';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import { TextField, CircularProgress } from '@mui/material';
import debounce from 'lodash/debounce';
import { getExtractValue } from '../../utils/formatName';
import { fetchSearchItems } from './helper/fetchSearchItems';

export default class DialogServerSearchField extends React.Component {
    static contextType = AppDataContext;

    constructor(props) {
        super(props);
        this.state = {
            options: props.options || [],
            inputValue: '',
            loading: false
        };
        this.debouncedFetchOptions = debounce(this.fetchOptions, 600);
    }

    componentDidMount() {
        this.state.options.length === 0 && this.fetchOptions('');
    }

    componentWillUnmount() {
        this.debouncedFetchOptions.cancel();
    }

    fetchOptions = async (query) => {
        // if (!query && this.state.options.length > 0) {
        //     return;
        // }

        this.setState({ loading: true });
        const server =
            this.context.getState().server[this.props.field.searchController];
        const searchFields = this.props.field.searchFields;
        const { outputField = 'id' } = this.props.field;
        try {
            const res = await fetchSearchItems(searchFields, query, server);
            if (res.error !== 'OK') {
                throw new Error('Error fetching options');
            }
            const data = res.data;
            const { show, translate, nestedObject, secondaryObject } =
                this.props.field;
            const mappedItems = data.map((item) => {
                const val = getExtractValue(
                    item,
                    show,
                    nestedObject,
                    secondaryObject
                );
                const translatedValue = translate
                    ? i18n.t(`${translate}.${val}`)
                    : val;
                return {
                    [outputField]: item[outputField],
                    value: translatedValue
                };
            });
            this.setState({ options: mappedItems });
        } catch (error) {
            console.error('Error fetching options:', error);
            this.setState({ options: [] });
        } finally {
            this.setState({ loading: false });
        }
    };

    checkIfValueExists = (value) => {
        const { options } = this.state;
        const { outputField = 'id' } = this.props.field;
        return options.some(
            (item) => item?.[outputField]?.toLowerCase?.() === value.toLowerCase()
        );
    };

    handleInputChange = (event, newInputValue) => {
        if (this.checkIfValueExists(newInputValue)) {
            this.setState({ inputValue: newInputValue });
            return;
        }
        this.setState({ inputValue: newInputValue });
        this.debouncedFetchOptions(newInputValue);
    };

    handleChanged = (field, value) => {
        const { outputField = 'id' } = this.props.field;
        if (value === null) {
            this.props.onChange(field, null);
        } else {
            this.props.onChange(field, value[outputField]);
        }
    };

    render() {
        const { field, value } = this.props;
        const { options, loading } = this.state;
        const { outputField = 'id' } = field;

        const translatedName = i18n.t(`columns.${field.label}`);
        return (
            <FormControl fullWidth sx={{ mt: 1 }}>
                <Autocomplete
                    value={
                        options.find((item) => item[outputField] === value) ||
                        null
                    }
                    onChange={(event, newValue) => {
                        this.handleChanged(field.id, newValue);
                    }}
                    onInputChange={this.handleInputChange}
                    options={options}
                    loading={loading}
                    getOptionLabel={(option) => option.value || ''}
                    isOptionEqualToValue={(option, val) =>
                        option[outputField] === val[outputField]
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={translatedName}
                            variant="outlined"
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {loading ? (
                                            <CircularProgress
                                                color="inherit"
                                                size={20}
                                            />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                    </>
                                )
                            }}
                        />
                    )}
                />
            </FormControl>
        );
    }
}
